export function errorPic(data, picSize, picPrefix) {
    if (picSize.length > 10) {
        data.src = picPrefix + picSize
    } else {
        data.src = require('@/assets/uploader/onloadpic.png')
    }
    // this.$nextTick(() => {
    var img = new Image();
    img.src = picPrefix + picSize
    img.onerror = function() {
            data.src = require('@/assets/uploader/onloadpic.png')
            img.onerror = null;
        }
        // });
    return data
}